import React from 'react'
import { Files } from '@constants'
import { Heap } from '@helpers'
import { Icon, Text, IconText } from '@components/UI'

const Fallback = ({ type, url, name, visibility }) => {
  return (
    <div className='gp-preview-fallback'>
      <div className='gp-preview-fallback-message'>
        <Icon name='no preview' />
        <Text style={{ opacity: 0.35, textAlign: 'center', marginTop: 16 }}>
          No preview available
        </Text>
      </div>

      <a
        href={url}
        onClick={() => {
          if (Files.SUPPORTED_FILE_TYPES.LINK.includes(type))
            Heap.trigger('Preview - Click - Link on Resource')
          else if (visibility === 'public')
            Heap.trigger('Preview - Download - Public File')
          else Heap.trigger('Preview - Download - Private File')
        }}
        className='ui gp-box box-a4 gp-button theme theme-f interactive'
        rel='noopener noreferrer'
        target='_blank'
        style={{ marginTop: 20, lineHeight: '14px' }}
        {...(Files.SUPPORTED_FILE_TYPES.LINK.includes(type)
          ? {}
          : { donwload: name })}
      >
        {Files.SUPPORTED_FILE_TYPES.LINK.includes(type) ? (
          <IconText value='Open' icon='link' group='a2' />
        ) : (
          <IconText value='Download' icon='download-outline' group='a2' />
        )}
      </a>
    </div>
  )
}

export default Fallback
